import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'Access-control-allow-headers': 'Authorization',
  },
})

const getAllAppraisalTypes = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/appraisal-types',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
}

export default {
  getAllAppraisalTypes,
}
